<template>
  <generic-container
    :title="$t('feedback 360 survey')"
    icon="edit"
    :show_refresh="true"
    :header_buttons="header_buttons"
    @refresh="load"
  >
    <!-- <h2 class="ui header">
      <img src="/images/icons/survey.png" />
      <div class="content">
        {{ $t("feedback 360 survey management") }}
      </div>
    </h2> -->
    <table
      class="ui blue very compact celled striped selectable table"
      ref="table"
      style="width:100%"
    >
      <thead>
        <tr>
          <th>{{ $t("create date") }}</th>
          <th>{{ $t("status") }}</th>
          <th>{{ $t("survey template") }}</th>
          <th>{{ $t("reason") }}</th>
          <th>{{ $t("evaluated") }}</th>
          <!-- <th>{{ $t("node") }}</th> -->
          <th>{{ $t("options") }}</th>
        </tr>
      </thead>
      <tbody></tbody>
    </table>
  </generic-container>
</template>

<script>
import filters from "@/filters";
import GenericContainer from "@/components/GenericContainer";
import { init_ajax_data_datables, enterprise_setup } from "@/utils";

export default {
  name: "Feedback360Index",
  components: { GenericContainer },
  filters: filters,
  data() {
    return {
      show_composer: false,
      last_run_time: undefined,
      header_buttons: [
        { icon: "left arrow", tooltip: this.$t("back"), click: this.back },
      ],
    };
  },
  computed: {
    enterprise_setup() {
      return enterprise_setup(this);
    },
  },
  methods: {
    translate_reason(reason) {
      let vm = this;
      switch (reason) {
        case "superior_survey":
          return vm.$t("superior survey");
        case "inferior_survey":
          return vm.$t("inferior survey");
        case "same_level_survey":
          return vm.$t("same level survey");
        case "auto_survey":
          return vm.$t("auto survey");
        default:
          return reason;
      }
    },
    load() {
      let vm = this;

      let columns = [
        {
          data: function(row) {
            return filters.formatDate(
              row.create_date,
              vm.enterprise_setup.detailed_date_format,
            );
          },
        },
        {
          data: function(row) {
            return vm.translate_status(row.status_code);
          },
        },
        {
          data: function(row) {
            // return row.survey_template.name;
            return row.staff_rating_template.name;
          },
        },
        {
          data: function(row) {
            return vm.translate_reason(row.reason);
          },
        },
        {
          data: function(row) {
            return row.evaluated_user.name;
          },
        },
        // {
        //   data: function(row) {
        //     // return `<pre>${JSON.stringify(row.source_node, null, 2)}</pre>`;
        //     console.log(row);
        //     return "";
        //   },
        // },
        {
          data: function(row) {
            return `<div class="ui mini icon basic button" onclick="window.dispatchEvent(new CustomEvent('run_survey', { detail: { uuid: '${row.uuid}'}}))">
                      <i class="green play icon"></i>
                    </div>`;
          },
        },
      ];

      let onSelect = (/* data */) => {
        // vm.show_student(data);
      };

      init_ajax_data_datables(
        vm,
        vm.$refs.table,
        // window.jQuery.fn.api.settings.api["feedback 360 survey user url"],
        window.jQuery.fn.api.settings.api["feedback 360 evaluation user url"],
        columns,
        onSelect,
      );
    },
    translate_status(status_code) {
      switch (status_code) {
        case "U":
          return `<i class="outline clock icon"></i>${this.$t("unfinished")}`;
        case "F":
          return `<i class="green check icon"></i>${this.$t("finished")}`;
        case "E":
          return `<i class="red clock outline icon"></i>${this.$t("expired")}`;
        default:
          return status_code;
      }
    },
    back() {
      this.$router.go(-1);
    },
  },
  mounted() {
    this.load();
  },
  created() {
    let vm = this;
    window.addEventListener(
      "run_survey",
      function(e) {
        e.stopImmediatePropagation();
        e.stopPropagation();
        e.preventDefault();
        let now = Date.now();
        // console.log("comparing", now, "and", vm.last_run_time);
        if (vm.last_run_time == undefined || now - vm.last_run_time > 1000) {
          vm.last_run_time = now;
          let uuid = e.detail.uuid;
          window.open(`#/feedback360/run?u=${uuid}`, "_blank");
        }
      },
      false,
    );
  },
};
</script>

<style></style>
